export default __webpack_public_path__ + "static/javascript-cover-b93fb6fc146447d7d3d428cf85bafef7.jpg";